import { InjectionToken } from '@angular/core';
import { UsageCounterStorage } from './usage-counter-storage';

/**
 * Batching cadence for UsageCounterService (CSW-1643). Both fields are
 * optional — omit either (or the whole token) to use the defaults below.
 * Configurable per-app (e.g. web-app vs chrome-extension) without touching
 * the service.
 */
export interface UsageCounterBatchingConfig {
  /** How often to flush the accumulated count, in ms. Default: 60s. */
  flushIntervalMs?: number;
  /** Flush immediately once the accumulated count reaches this many. Default: 50. */
  flushThreshold?: number;
}

export const DEFAULT_USAGE_COUNTER_FLUSH_INTERVAL_MS = 60_000;
export const DEFAULT_USAGE_COUNTER_FLUSH_THRESHOLD = 50;

export const CAPICHE_USAGE_COUNTER_CONFIG = new InjectionToken<UsageCounterBatchingConfig>(
  'CapicheUsageCounterConfig',
);

/**
 * Optional storage override — provide this token with a `localStorage`-backed
 * (or other durable) `UsageCounterStorage` implementation to persist unflushed
 * counts across reloads. Defaults to in-memory (see usage-counter-storage.ts).
 */
export const CAPICHE_USAGE_COUNTER_STORAGE = new InjectionToken<UsageCounterStorage>('CapicheUsageCounterStorage');
